import { DialogFlowMessage } from '@/models/Chat';
import { Person } from '@/models/Person';
import { LocaleData } from '@/translations/LocaleData';

export enum MessageType {
    USER = 'USER',
    MESSAGE = 'MESSAGE',
    PAYLOAD = 'PAYLOAD',
}

export enum PayloadType {
    IMAGE = 'image',
    CHIPS = 'chips',
    ACTION = 'action',
}

export type BufferingMessages = [number, number];

export interface EmptyContentProps {
    avatar: string;
    strings: LocaleData;
    person: Person;
}

export interface ContentProps {
    avatar: string;
    strings: LocaleData;
    person: Person;
    chat: {
        messages: any;
        loading: boolean;
    };
    sendMessage: Function;
    buffering: BufferingMessages;
    positionY: number;
}

export interface MessageProps {
    lastMessage: DialogFlowMessage;
    message: DialogFlowMessage;
    sendMessage: Function;
    index: number;
}
